<template>
    <div class="form_list rsv_notice_chat">
        <div class="w_65">
            <table class="table2_default no_hover top th_center">
                <thead>
                <tr>
                    <th width="130px">항목</th>
                    <th>알림 내용</th>
                    <th width="80px">상태</th>
                </tr>
                </thead>
                <tr>
                    <td>
                        <p class="txt_center mgb_10"><b>예약 당일 안내</b></p>
                        <select class="input_s w_full" v-model="rTimeIndex">
                            <option :value="8">오전 08:00</option>
                            <option :value="9">오전 09:00</option>
                            <option :value="10">오전 10:00</option>
                            <option :value="11">오전 11:00</option>
                            <option :value="12">오후 12:00</option>
                            <option :value="13">오후 01:00</option>
                            <option :value="14">오후 02:00</option>
                            <option :value="15">오후 03:00</option>
                            <option :value="16">오후 04:00</option>
                            <option :value="17">오후 05:00</option>
                            <option :value="18">오후 06:00</option>
                            <option :value="19">오후 07:00</option>
                            <option :value="20">오후 08:00</option>
                        </select>
                    </td>
                    <td>
                        <textarea rows="5" class="w_full" placeholder="고객에게 보낼 예약 알림 내용을 입력해 주세요." maxlength="500" v-model="reservationNotificationMessage" spellcheck="false" @focus="action_Focus('reservationNotificationMessage')"></textarea>
                        <a class="btn btn_underline blue_txt mgt_10 fr" @click="action_Preview('noti')">미리보기</a>
                    </td>
                    <td><label class="check_wrap"><input type="checkbox" v-model="usingReservationNotification"><span class="checkmark"></span> 사용</label></td>
                </tr>
                <tr>
                    <td>
                        <p class="txt_center mgb_10"><b>예약 전날 안내</b></p>
                        <select class="input_s w_full" v-model="rbTimeIndex">
                            <option :value="8">오전 08:00</option>
                            <option :value="9">오전 09:00</option>
                            <option :value="10">오전 10:00</option>
                            <option :value="11">오전 11:00</option>
                            <option :value="12">오후 12:00</option>
                            <option :value="13">오후 01:00</option>
                            <option :value="14">오후 02:00</option>
                            <option :value="15">오후 03:00</option>
                            <option :value="16">오후 04:00</option>
                            <option :value="17">오후 05:00</option>
                            <option :value="18">오후 06:00</option>
                            <option :value="19">오후 07:00</option>
                            <option :value="20">오후 08:00</option>
                        </select>
                    </td>
                    <td>
                        <textarea rows="5" class="w_full" placeholder="고객에게 보낼 예약 알림 내용을 입력해 주세요." v-model="reservationBNotificationMessage" maxlength="500" spellcheck="false" @focus="action_Focus('reservationBNotificationMessage')"></textarea>
                        <a class="btn btn_underline blue_txt mgt_10 fr" @click="action_Preview('notiB')">미리보기</a>
                    </td>
                    <td><label class="check_wrap"><input type="checkbox" v-model="usingReservationBNotification"><span class="checkmark"></span> 사용</label></td>
                </tr>
            </table>
        </div>
        <div class="w_35 mgl_10 relative">
            <div class="txt_preview_wrap" v-if="isShowPreview">
                <div class="txt_preview_top">
                    <span class="txt_preview_title" v-if="previewType=='noti'">당일 안내 문구 미리보기</span>
                    <span class="txt_preview_title" v-if="previewType=='notiB'">전날 안내 문구 미리보기</span>
                    <a class="mgl_auto" @click="action_ClosePreview"><v-icon small>mdi-close</v-icon></a>
                </div>
                <div class="txt_preview_cont">
                    <div class="bubble"><pre>{{ previewNotiString }}</pre></div>
                </div>
            </div>
            <table class="table2_default no_hover">
                <colgroup>
                    <col width="115px">
                    <col width="">
                </colgroup>
                <tr>
                    <th colspan="2">
                        치환문자 참고
                        <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
                        <span class="tooltip_wrap">
                            <span class="tooltip">
                                치환문자를 활용하여 고객 별로 예약일정에 대한 안내를 할 수 있습니다.
                                알림 내용에 치환문자가 입력된 경우, 고객이 알림을 받았을 때 해당 문자가 치환되어 발송됩니다.
                            </span>
                        </span>
                    </th>
                </tr>
                <tr>
                    <th>입력</th>
                    <th>치환 문구 예시</th>
                </tr>
                <tr>
                    <td><span class="label lgray">{{sign_Name}}</span></td>
                    <td>홍길동</td>
                </tr>
                <tr>
                    <td><span class="label lgray">{{sign_Program}}</span></td>
                    <td>도수치료 A코스</td>
                </tr>
                <tr>
                    <td><span class="label lgray">{{sign_Column}}</span></td>
                    <td>이철수</td>
                </tr>
                <tr>
                    <td><span class="label lgray">{{sign_ReservationTime}}</span></td>
                    <td>2023년 07월 03일(월) 13:00</td>
                </tr>
                <tr>
                    <td><span class="label lgray">{{sign_ReservationDate}}</span></td>
                    <td>2023년 07월 03일(월)</td>
                </tr>
                <tr>
                    <td><span class="label lgray">{{sign_ReservationStartTime}}</span></td>
                    <td>13:00</td>
                </tr>
                <tr>
                    <td><span class="label lgray">{{sign_ReservationEndTime}}</span></td>
                    <td>14:00</td>
                </tr>
            </table>
        </div>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
const moment = require('../../../../../../../util/MPMoment')
export default {
    props: {
        value: Object
    },
    data() {
        return {
            rTimeIndex: 8,
            reservationNotificationTime: moment(),
            reservationNotificationMessage: '{{고객명}}님 예약 안내 드립니다.\n▶ 예약일자 : {{예약일시}}\n▶ 예약내용 : {{프로그램명}}\n▶ 담당자명 : {{담당자명}}\n[안내사항]\n- 예약내역은 애프터닥 앱 [예약 내역]에서 확인할 수 있습니다.\n- 늦으실 경우 뒤에 예약 환자분들의 치료가 미뤄집니다. 5분 전에 내원하셔서 접수 및 환복 후 시간에 맞춰 입실 부탁드리겠습니다.',
            usingReservationNotification: false,

            rbTimeIndex: 20,
            reservationBNotificationTime: moment(),
            reservationBNotificationMessage: '{{고객명}}님 내일 치료 안내 드립니다.\n▶ 예약일자 : {{예약일시}}\n▶ 예약내용 : {{프로그램명}}\n▶ 담당자명 : {{담당자명}}\n[안내사항]\n- 예약내역은 애프터닥 앱 [예약 내역]에서 확인할 수 있습니다.\n- 늦으실 경우 뒤에 예약 환자분들의 치료가 미뤄집니다. 5분 전에 내원하셔서 접수 및 환복 후 시간에 맞춰 입실 부탁드리겠습니다.',
            usingReservationBNotification: false,
            isReservationBNotiError: false,

            sign_Name: "{{고객명}}",
            sign_Program: "{{프로그램명}}",
            sign_ReservationTime: "{{예약일시}}",
            sign_Column: "{{담당자명}}",
            sign_ReservationDate: "{{예약일}}",
            sign_ReservationStartTime: "{{시작시간}}",
            sign_ReservationEndTime: "{{종료시간}}",

            isShowPreview: false,
            previewType: 'noti', // noti, notiB
            convertDic: {
                sign_Name:                  "홍길동",
                sign_Program:               "도수치료 A코스",
                sign_Column:                "이철수",
                sign_ReservationTime:       "2023년 07월 03일(월) 13:00",
                sign_ReservationDate:       "2023년 07월 03일(월)",
                sign_ReservationStartTime:  "13:00",
                sign_ReservationEndTime:    "14:00",
            }
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                if (newValue == undefined) { return }
                if (newValue.reservationNotificationTime != undefined) {
                    this.reservationNotificationTime = moment(newValue.reservationNotificationTime)
                    this.rTimeIndex = this.reservationNotificationTime.hours()
                }
                if (newValue.reservationNotificationMessage != undefined && newValue.reservationNotificationMessage != '') {
                    this.reservationNotificationMessage =newValue.reservationNotificationMessage
                }
                this.usingReservationNotification = newValue.usingReservationNotification
                if (newValue.usingReservationNotification == undefined) {
                    this.usingReservationNotification = true
                }

                if (newValue.reservationBNotificationTime != undefined) {
                    this.reservationBNotificationTime = moment(newValue.reservationBNotificationTime)
                    this.rbTimeIndex = this.reservationBNotificationTime.hours()
                }
                if (newValue.reservationBNotificationMessage != undefined && newValue.reservationNotificationMessage != '') {
                    this.reservationBNotificationMessage = newValue.reservationBNotificationMessage != undefined ? newValue.reservationBNotificationMessage : ''
                }
                this.usingReservationBNotification = newValue.usingReservationBNotification
                if (newValue.usingReservationBNotification == undefined) {
                    this.usingReservationBNotification = true
                }
            }
        },
        rTimeIndex:                         { immediate: true, handler: function(newValue, oldValue) { if (newValue != oldValue) this.updateValue() } },
        reservationNotificationMessage:     { immediate: true, handler: function(newValue, oldValue) { if (newValue != oldValue) this.updateValue() } },
        usingReservationNotification:       { immediate: true, handler: function(newValue, oldValue) { if (newValue != oldValue) this.updateValue() } },
        rbTimeIndex:                        { immediate: true, handler: function(newValue, oldValue) { if (newValue != oldValue) this.updateValue() } },
        reservationBNotificationMessage:    { immediate: true, handler: function(newValue, oldValue) { if (newValue != oldValue) this.updateValue() } },
        usingReservationBNotification:      { immediate: true, handler: function(newValue, oldValue) { if (newValue != oldValue) this.updateValue() } }
    },
    computed: {
        previewNotiString: function() {
            let string = this.reservationNotificationMessage
            if (this.previewType == 'notiB') {
                string = this.reservationBNotificationMessage
            }

            let keys = Object.keys(this.convertDic)
            for (let i=0 ; i<keys.length ; i++) {
                let key = keys[i]
                let word = this.convertDic[key]
                let target = this[key]
                string = string.replaceAll(target, word)
            }
            return string
        }
    },
    methods: {
        updateValue() {
            let reservationNotiTime = moment().startOf('days').add(this.rTimeIndex, 'hours')
            let reservationBNotiTime = moment().startOf('days').add(this.rbTimeIndex, 'hours')

            let newModel = deepCopy(this.value)
            newModel.reservationNotificationTime = reservationNotiTime
            newModel.reservationNotificationMessage = this.reservationNotificationMessage
            newModel.usingReservationNotification = this.usingReservationNotification
            newModel.reservationBNotificationTime = reservationBNotiTime
            newModel.reservationBNotificationMessage = this.reservationBNotificationMessage
            newModel.usingReservationBNotification = this.usingReservationBNotification

            this.$emit('input', newModel)
        },

        // MARK: - Actions
        action_Preview(type) {
            let beforeType = this.previewType

            this.previewType = type
            if (this.previewType == beforeType) {
                this.isShowPreview = !this.isShowPreview
            } else {
                this.isShowPreview = true
            }
        },
        action_ClosePreview() {
            this.isShowPreview = false
        },
        action_Focus(type) {
            if (this.reservationNotificationMessage.replaceAll(' ', '') == '' && type == 'reservationNotificationMessage') {
                this.$emit('action_Focus')
            }
            if (this.reservationBNotificationMessage.replaceAll(' ', '') == '' && type == 'reservationBNotificationMessage') {
                this.$emit('action_Focus')
            }
        }
    }
}
</script>